export const schema = {
    "models": {
        "QuickPcr": {
            "name": "QuickPcr",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "indexNumber": {
                    "name": "indexNumber",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "firstName": {
                    "name": "firstName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "middleName": {
                    "name": "middleName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "lastName": {
                    "name": "lastName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "personalId": {
                    "name": "personalId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "age": {
                    "name": "age",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "complaints": {
                    "name": "complaints",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "contacted": {
                    "name": "contacted",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "payment": {
                    "name": "payment",
                    "isArray": false,
                    "type": {
                        "enum": "Payment"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "previousTests": {
                    "name": "previousTests",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "testType": {
                    "name": "testType",
                    "isArray": false,
                    "type": {
                        "enum": "TestType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "testResult": {
                    "name": "testResult",
                    "isArray": false,
                    "type": {
                        "enum": "TestResult"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "testDate": {
                    "name": "testDate",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "resultDate": {
                    "name": "resultDate",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "sex": {
                    "name": "sex",
                    "isArray": false,
                    "type": {
                        "enum": "Sex"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "comment": {
                    "name": "comment",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "published": {
                    "name": "published",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "phoneNumber": {
                    "name": "phoneNumber",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "checkedOut": {
                    "name": "checkedOut",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "code": {
                    "name": "code",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "QuickPcrs",
            "attributes": [
                {
                    "type": "model",
                    "properties": {}
                }
            ]
        }
    },
    "enums": {
        "Payment": {
            "name": "Payment",
            "values": [
                "Payed",
                "RZI",
                "MBAL",
                "NotPayed",
                "Razlog",
                "TUB",
                "AUB",
                "PIRIN"
            ]
        },
        "TestType": {
            "name": "TestType",
            "values": [
                "QuickTest",
                "Pcr"
            ]
        },
        "TestResult": {
            "name": "TestResult",
            "values": [
                "Positive",
                "Negative",
                "Doubtful",
                "InProgres"
            ]
        },
        "Sex": {
            "name": "Sex",
            "values": [
                "Male",
                "Female"
            ]
        }
    },
    "nonModels": {},
    "version": "9e0248dc982c43584bbda8bb727e9345"
};